import { FormEnumFieldWidget } from '@kunlun/dependencies';

type EnumerationValue = boolean | string;

export interface Subscriber {
  (val: EnumerationValue | null | undefined): void;
}

export class EnumerationValueFieldChangeEventBus {
  private widget: FormEnumFieldWidget;
  private subscriberList: Subscriber[];
  private subscriberMap: Map<any, Subscriber>;

  constructor(widget: FormEnumFieldWidget) {
    this.widget = widget;
    this.subscriberList = [];
    this.subscriberMap = new Map();
  }

  subscribe(subscriber: Subscriber) {
    if (subscriber) {
      this.subscriberList.push(subscriber);
    }
  }

  subscribeMap(key: any, subscriber: Subscriber) {
    if (subscriber) {
      this.subscriberMap.set(key, subscriber);
    } else {
      this.subscriberMap.delete(key);
    }
  }

  publish(val: EnumerationValue | null | undefined) {
    this.subscriberList.forEach((it) => it && it(val));
    this.subscriberMap.forEach((value, key) => {
      value(val);
    });
  }
}
